// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3AqS4","noInteraction":"EventWrapper_noInteraction__2nsUr"};